<template>
    <div class="library-deliverable-table-status-cell">
        <QaStatusLabel display="block" :is-clickable="true" :status="status" @click="$emit('click')" />
    </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";

import QaStatusLabel from "@/components/Qa/QaStatusLabel.vue";
import type { BannerQaStatus } from "@/enums/banners";

export default defineComponent({
    components: {
        QaStatusLabel
    },
    props: {
        status: {
            required: true,
            type: String as PropType<(typeof BannerQaStatus)[keyof typeof BannerQaStatus]>
        }
    },
    emits: ["click"]
});
</script>

<style lang="scss">
@use "@style/variables" as *;
</style>
